import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { apiSetup } from '../config/api';
import { AuthProvider } from '../contexts/AuthContext';

import AppRoutes from './components/Routes';
import '../scss/application.scss';
import 'react-input-range/lib/css/index.css';

class App extends Component {
  componentDidMount() {
    // Register apisauce transforms + the 401 silent-fallback monitor.
    apiSetup();
  }

  render() {
    return (
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    );
  }
}

App.defaultProps = {
  loading: false
};

export default App;
